module.exports = __webpack_public_path__ + "static/media/MUHAMMED HAK .668b004c.png";